// // media slider  
// const swiperMediaCards = new Swiper('.media__slider__cards', {
//     loop: true,
//     spaceBetween: 0,
//     slidesPerView: 'auto',
//     speed: 800,
//     watchSlidesProgress: true,
//     autoplay: {
//       delay: 3000, 
//       disableOnInteraction: false,
//     },
// });

let swiperMediaCards = null;

function initMediaSlider() {
    const sliderEl = document.querySelector('.media__slider__cards');
    
    if (!sliderEl) return;

    const isInsideMediaBanner = sliderEl.closest('.media__banner');
    const screenWidth = window.innerWidth;

    if (isInsideMediaBanner && screenWidth >= 992 && swiperMediaCards) {
        swiperMediaCards.destroy(true, true);
        swiperMediaCards = null;
        return;
    }

    if ((isInsideMediaBanner && screenWidth < 992 && !swiperMediaCards) || 
        (!isInsideMediaBanner && !swiperMediaCards)) {
        
        swiperMediaCards = new Swiper(sliderEl, {
            loop: true,
            spaceBetween: 0,
            slidesPerView: 'auto',
            speed: 800,
            watchSlidesProgress: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        });
    }
}

initMediaSlider();

window.addEventListener('resize', initMediaSlider);